export default __webpack_public_path__ + "static/media/video-cover-processing.d76379a3.svg";